import { defaultSite } from '../models/RequestAccessModels';
import { WidgetProps } from '../models/RequestAccessWidgetProps';
import { PopsApi, ServicesApi } from 'services/ApiService/RequestAccessProxy/RequestAccessProxyApi';
import { PopsApplicationProfilesProvider, PopsUserAccessDetailsProvider, Service } from 'services/ApiService/RequestAccessProxy/RequestAccessProxyApiClient';

export const getService = async (
  widgetProps: WidgetProps,
): Promise<Service> => {
  const ressourceId = widgetProps.ressourceId || widgetProps.site?.ressourceId || undefined;
  try {
    const encodedUrl = widgetProps.url ? btoa(widgetProps.url) : '';
    const service = await ServicesApi.searchService(ressourceId, encodedUrl);
    return service ?? defaultSite;

  } catch {
    return defaultSite;
  }
};

export const getPopsAccessResult = async (
  popsIdentifier: string,
): Promise<PopsUserAccessDetailsProvider> => {
  return await PopsApi.getUserAccess(popsIdentifier);
};

export const getPopsApplicationProfileResult = async (
  popsIdentifier: string,
): Promise<PopsApplicationProfilesProvider> => {
  return await PopsApi.getApplicationProfiles(popsIdentifier);
};
